<template>
  <div class="container">
    <div class="contactus">关于我们</div>
    <img src="../../assets/img/aboutus/map.jpg" style="width:100%;margin-top:0px;" alt="地图"> 
    <div class="contactus">联系我们</div>
    <div class="detail">
      <div class="detailItem"><div class="detailItemTop">产品咨询</div><span class="detailItemBottom1">13001001954</span></div>
      <div class="detailItem"><div class="detailItemTop">技术支持</div><span class="detailItemBottom2">jvshikeji@163.com</span></div>
      <div class="detailItem"><div class="detailItemTop">市场合作</div><span class="detailItemBottom3">jvshikeji@163.com</span></div>
      <div class="detailItem"><div class="detailItemTop">加入我们</div><span class="detailItemBottom4">jvshikeji@163.com</span></div>
    </div>
    <br>
    <frontFooter></frontFooter>
  </div>
</template>

<script>
import frontFooter from '@c/navigation/frontFooter.vue'
export default {
  components: {
    frontFooter
  },
  mounted () {
    document.title = '美钥二维码-关于我们'
  }
}
</script>


<style scoped>
.contactus {
  margin: 20px auto;
  font-size: 35px;
  text-align: center;
}
.detail {
  width: 80%;
  margin-left: 10%;
   float: left; 
  text-align: center;
  font-size: 25px;
  margin-bottom: 50px;
}
.detailItem {
   float: left; 
  width: 25%;
   margin-left: 30px; 
   margin: 0 auto;
}
.detailItemTop {
  background: #70d5f8;
  width: 98%;
  margin-left: 1%;
  height: 100px;
  line-height: 100px;
  color: white;
}
.detailItemBottom1,
.detailItemBottom2,
.detailItemBottom3,
.detailItemBottom4 {
  font-size: 20px;
  line-height: 100px;
}
@media (max-width: 768px) {
  .detail {
    font-size: 10px;
  }
  .detailItemBottom1,
  .detailItemBottom2,
  .detailItemBottom3,
  .detailItemBottom4 {
    font-size: 10px;
  }
  .map {
    background-size: contain;
  }
}
@media (max-width: 420px) {
  .map {
    height: 300px;
  }
  .detailItemBottom1 {
    font-size: 10px;
  }
  .detailItemBottom2,
  .detailItemBottom4 {
    display: none;
  }
}
</style>
